export default "__VITE_ASSET__1xsAZoQy__"